export default {
  activate: 'Activate user',
  activateUser: 'Activate user',
  activateWarning: 'Are you sure you want to activate selected users?',
  add: 'Add user',
  addCellsToUsers: 'Add cells to users',
  addGroupsToUsers: 'Add groups to users',
  all: 'All people',
  allCells: 'All cells',
  assign: 'Assign',
  balance: 'Balance',
  block: 'Block user',
  blockedSingular: 'Blocked user',
  blockedPlural: 'Blocked users',
  blockUser: 'Block user',
  blockWarning: 'Are you sure you want to block selected users?',
  create: 'Create user',
  clientsPlural: 'Clients',
  cm: 'CM',
  createShare: 'Create share',
  changePassword: 'Change password',
  changeEmail: 'Change email',
  clearUserCache: 'Clear user cache',
  delete: 'Delete user',
  deleteAccount: 'Delete account',
  id: 'ID',
  iConfirmThatIHaveReviewedTheImportantPointsAndAgreeToComplyWithThem:
    'I confirm that I have reviewed the important points and agree to comply with them.',
  notificationOfTemporaryBlocking: 'Notification of temporary blocking',
  debt: 'Debt',
  group: 'Group',
  groups: 'Groups',
  edit: 'Edit user',
  invite: 'Invite user',
  plural: 'Users',
  pluralLowerCase: 'users',
  workersPlural: 'Workers',
  pluralDowncase: 'users',
  search: 'Search users',
  select: 'Select user...',
  selectClient: 'Select client...',
  selected: 'Selected users',
  singular: 'User',
  sigmaPayments: 'Σ Payments',
  unblock: 'Unblock user',
  update: 'Update user',
  createdSuccess: 'User successfully created.',
  deletedSuccess: 'User successfully deleted.',
  info: 'User Info',
  count: 'Users {count}',
  updatedSuccess: 'User successfully updated.',
  name: 'Name',
  phone: 'Phone',
  pm: 'PM',
  email: 'Email',
  financeRole: 'Finance role',
  experience: 'Experience',
  editShare: 'Edit share',
  revenue: 'Revenue',
  kAvr: 'K AVR',
  kEdp: 'K EDP',
  lastPayments: 'Last Payments',
  lastActivity: 'Last Activity',
  legalInformationUpdate: 'Legal information update',
  mentor: 'Mentor',
  cell: 'Cell',
  role: 'Role',
  roles: 'Roles',
  createdAt: 'Created at',
  pendingPayments: {
    plural: 'Pending payments',
    singular: 'Pending payment',
    types: {
      badDebt: 'Bad debt',
      debt: 'Debt',
      underpayment: 'Underpayment'
    },
    no: 'No pending payments'
  },
  status: 'Status',
  statusUpdated: 'Status updated',
  statuses: {
    new: 'New',
    active: 'Active',
    paused: 'Paused',
    declined: 'Declined',
    realDecline: 'Real decline',
    noPayments: 'No payments'
  },
  cdn: {
    usa: 'USA ($$$)',
    eu: 'EU (Free)'
  },
  unassign: 'Unassign',
  unblockUser: 'Unblock user'
};
